export const GESTION = [["presupuesto", "Presupuesto"], ["comisiones", "Comisiones"], ["descuentos", "Descuentos"], ["extraordinarios", "Extraordinarios"]];
export const FIJA = [["impuestos", "Impuestos"], ["comisiones_bancarias", "Comisiones Bancarias e Intereses"], ["gasto_corporativo", "Gasto Corporativo"],
  ["provisiones", "Provisiones"], ["inversiones", "Inversiones"], ["pagos_capital", "Pagos de Capital a PQ/MP"], ["otros_programas", "Otros Programas"]];
// Igual que el formato: el total de gasto fijo no incluye Pagos de Capital.
const FIJA_TOTAL = FIJA.map(([k]) => k).filter((k) => k !== "pagos_capital");

const n = (v) => (v == null || v === "" ? 0 : Number(v));
const perKg = (imp, k) => (imp == null ? null : k ? imp / k : 0);
const sub = (...xs) => (xs.some((x) => x == null) ? null : xs.slice(1).reduce((a, b) => a - b, xs[0]));

function column(vals, col, cne, flete, planBaseImp) {
  const v = (key) => n(vals[key]?.[col]);
  const k = v("venta_kg");
  const cif = v("cif");
  const r = { kilos: k, cne: { kg: cne, imp: cne == null ? null : cne * k }, cif: { kg: cif, imp: cif * k }, flete: { kg: flete, imp: flete == null ? null : flete * k } };
  r.margen = { kg: sub(cne, cif, flete), imp: sub(r.cne.imp, r.cif.imp, r.flete.imp) };
  GESTION.forEach(([key]) => { r[key] = { imp: v(key), kg: perKg(v(key), k) }; });
  const hgPct = v("hg_pct");
  const hgKilos = (hgPct / 100) * k;
  r.hg_pct = { kg: hgPct, imp: hgKilos };
  r.hg = { imp: flete == null ? null : hgKilos * (cif + flete) };
  r.hg.kg = perKg(r.hg.imp, k);
  r.cartera = { imp: v("cartera"), kg: perKg(v("cartera"), k) };
  const op = [...GESTION.map(([key]) => r[key].imp), r.hg.imp, r.cartera.imp];
  r.costo_op = { imp: op.some((x) => x == null) ? null : op.reduce((a, b) => a + b, 0) };
  r.costo_op.kg = perKg(r.costo_op.imp, k);
  FIJA.forEach(([key]) => { r[key] = { imp: v(key), kg: perKg(v(key), k) }; });
  r.total_fijo = { imp: FIJA_TOTAL.reduce((a, key) => a + r[key].imp, 0) };
  r.total_fijo.kg = perKg(r.total_fijo.imp, k);
  r.utilidad = { imp: sub(r.margen.imp, r.costo_op.imp, r.total_fijo.imp) };
  r.utilidad.kg = perKg(r.utilidad.imp, k);
  const baseImp = planBaseImp === undefined ? v("utilidad_base") * k : k ? planBaseImp : 0;
  r.utilidad_base = { imp: baseImp, kg: planBaseImp === undefined ? v("utilidad_base") : perKg(baseImp, k) };
  r.margen_gest = { imp: sub(r.utilidad.imp, baseImp) };
  r.margen_gest.kg = perKg(r.margen_gest.imp, k);
  return r;
}

// Encabezado de semana: verde si cumple, rojo si no.
export const ACTUAL_COLOR = "#3B9AE1";
export const semaforoColor = (v) => (v === true ? "#15803d" : v === false ? "#b91c1c" : undefined);

export function calcReporte(vals, cne, flete) {
  const plan = column(vals, "plan", cne, flete);
  const real = column(vals, "real", cne, flete, plan.utilidad_base.imp);
  const liberada = plan.utilidad.imp == null ? null : plan.utilidad.imp >= plan.utilidad_base.imp;
  return { plan, real, liberada };
}
